import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function VendorPaymentsCtrl ($state, $scope, $translate, Vendor, tableApi, workshopAPI) {

  $scope.showVendorPayments = !!$scope.payments.length;
  $scope.tableCacheKey      = 'vendorPayments';

  $scope.Vendor = new Vendor($scope.vendor);

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'vendor_payment_number',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.PAYMENT_NUMBER')
        }
      },
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'customerPaymentStatus'
      },
      {
        classes: 'text-right',
        field  : 'applied_amount',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.APPLIED_AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : 'amount',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewPayment(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PAYMENTS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vendors/payment_count', $scope.vendor.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'post_date'
    })
  };

  $scope.getPayments = ( params ) => {
    return workshopAPI.get('/vendors/payment_list', [
      $scope.vendor.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
    ]).then(payments => {
      $scope.payments = payments;

      return payments;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewPayment(event.row);
  };

  $scope.viewPayment = function (invoice) {
    $state.go('app.vendor-payment', {
      id       : invoice.id,
      vendor_id: invoice.vendor_id
    });
  };

  $scope.createNewPayment = function () {
    $state.go($scope.Vendor.isBranchVendor() ? 'app.vendor-branch-payment' : 'app.vendor-payment', {
      vendor_id: $scope.vendor.id
    });
  };
}